<template>
  <div>
    <UtteranceControl
      v-bind="$attrs"
      :isSelfEnter="true"
      :disabled-enter="disabled"
      :customEndter="true"
      v-on="$listeners"
      @disabledEnter="handelDisabledEnter"
      @enter="handelEnter"
    >
    </UtteranceControl>
  </div>
</template>

<script lang="ts">
import { Vue, Component } from 'vue-property-decorator';
import { UtteranceControl } from '@/components/resources';
import { namespace } from 'vuex-class';
import { Auth } from '@/store/modules/common/types';

const common = namespace('common');

@Component({
  name: 'PhontAuthControl',
  components: {
    UtteranceControl
  }
})
export default class PhontAuthControl extends Vue {
  @common.State('auth') public auth!: Auth;

  get disabled() {
    return this.auth.phone.status === '';
  }

  handelDisabledEnter() {
    this.$Message.warn({
      time: 1500,
      content: '请选择是否授权'
    });
  }

  handelEnter() {
    window.next();
    this.$emit('next');
  }
}
</script>
